import BaseModel from "../core/BaseModel";
export default class UserModel extends BaseModel {
  constructor() {
    super(
      {
        name: "user",
        tableName: "users",
        label: "Danh Sách Người Dùng",
          display_key: 'fullname',
        /* display_key: 'fullname',
                 default_order: { key: 'updated_at', direction: 'asc' }*/
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          class: "xs-col",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        avatar : {
          name: 'avatar', 
          type: "Image", 
          label: 'Hình đại diện',
        },
        fullname: {
          name: "fullname",
          type: "String",
          label: "Tên hiển thị",
          // class: "large-col",
          filter: { type: "input", match: "contains" },
        },
        username: {
          name: "username",
          label: "Tên đăng nhập",
          type: "String",
          filter: { type: "input", match: "contains" },
        },
        email: {
          name: "email",
          label: "Email",
          type: "String",
          class: "large-col",
          filter: { type: "input", match: "contains" },
        },
        phone: {
          name: "phone",
          label: "Số điện thoại",
          type: "String",
          class: "small-col",
          sortable: false,
          filter: { type: "input", match: "contains" },
        },
        type_company: {
          name: "type_company",
          label: "Loại tài khoản",
          type: "Selection",
          custom: "SelectionText",
          class: "center small-col",
          options: [
            { value: 'internal', label: "Nội bộ" },
            { value: 'contractor', label: "Nhà thầu" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        department: {
          name: "department",
          label: "Bộ phận",
          type: "MultiSelect",
          filter: {
            type: "SelectScroll",
            optionLabel: "name",
            optionKey: "id",
            match: "equals",
          },
        },
        position: {
          name: "position",
          label: "Chức vụ",
          type: "MultiSelect",
          filter: { type: "input", match: "contains" },
        },
        active: {
          name: "active",
          label: "Hoạt động",
          type: "Selection",
          custom: "SelectionText",
          class: "center",
          options: [
            { value: true, label: "Đang hoạt động" },
            { value: false, label: "Không hoạt động" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối",
          class: "small-col",
          filter: { type: "DateRange", match: "contains" },
        },
      }
    );
  }
}
